import React, { useState } from "react";
import { Button, Modal, CloseButton } from "react-bootstrap";
import TransationGreen from "../assets/images/icon-transation-send.svg";
import TransationBlack from "../assets/images/icon-transation-send-light.svg";
import WaitngModel from "../Modals/WaitngModel";
import "./TransactionSubmitted.css";

function TransactionSubmitted() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="model-wraper">
        <div className="swap--button-wraper d-flex mt-4">
          <WaitngModel />
          <Button className=" swap--button" variant="primary" size="lg" onClick={handleShow}>
            Confirm
          </Button>
        </div>
        <Modal show={show} onHide={handleClose} className="transaction">
          <Modal.Header>
            <CloseButton variant="white" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            <div className="transaction-tag d-flex justify-content-center align-items-center">
              <img src={TransationGreen} alt="" className="transation-green" />
              <img src={TransationBlack} alt="" className="transation-black" />
            </div>
            <div className="d-flex justify-content-center align-items-center mt-5">
              <h1>Transaction Submitted</h1>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default TransactionSubmitted;
